// Emlak detay kartı + PDF için ortak etiketler ve satır üreticileri (web ve PDF aynı veriyi gösterir)
import { tesisTuruText, tesisTuruList } from '../../../utils/tesisTuru';

export const TUR_INFO = {
  arsa: { label: 'Arsa', tone: 'bg-green-900/50 text-green-300 border-green-700', pdf: [220, 252, 231] },
  yapi: { label: 'Yapı', tone: 'bg-blue-900/50 text-blue-300 border-blue-700', pdf: [219, 234, 254] },
  yapi_yikildi: { label: 'Yapı (YIKILDI)', tone: 'bg-red-900/50 text-red-300 border-red-700', pdf: [254, 226, 226] },
};
export const turInfo = (t) => TUR_INFO[t] || { label: t || '-', tone: 'bg-gray-700 text-gray-200 border-gray-600', pdf: [243, 244, 246] };
export const isYapiTuru = (t) => ['yapi', 'yapi_yikildi'].includes(t);

const MULKIYET_TR = {
  milli_emlak: 'Milli Emlak', ogm: 'OGM', belediye: 'Belediye', il_mudurlugu: 'İl Müdürlüğü',
  il_mudurlugu_kamulastirma: 'İl Müdürlüğü (Kamulaştırma)', kamu_kurum: 'Kamu Kurum ve Kuruluşları', diger: 'Diğer',
};
export const mulkiyetText = (e) => MULKIYET_TR[e.mulkiyet] || e.mulkiyet || '';
export const belediyeText = (v) => (v === 'istanbul_buyuksehir' ? 'İstanbul Büyükşehir Belediyesi' : v ? `${String(v).toLocaleUpperCase('tr')} Belediyesi` : '');

export const TAHSIS_TR = { hayir: 'Hayır', tahsis_verildi: 'Tahsis Verildi', kiraya_verildi: 'Kiraya Verildi', kiralandi: 'Kiralandı' };
const TAHSIS_TONE = {
  hayir: { tone: 'bg-gray-700 text-gray-200 border-gray-600', pdf: [243, 244, 246] },
  tahsis_verildi: { tone: 'bg-cyan-900/50 text-cyan-300 border-cyan-700', pdf: [207, 250, 254] },
  kiraya_verildi: { tone: 'bg-purple-900/50 text-purple-300 border-purple-700', pdf: [243, 232, 255] },
  kiralandi: { tone: 'bg-fuchsia-900/50 text-fuchsia-300 border-fuchsia-700', pdf: [250, 232, 255] },
};
const OLUMLU = { tone: 'bg-emerald-900/50 text-emerald-300 border-emerald-700', pdf: [209, 250, 229] };
const OLUMSUZ = { tone: 'bg-red-900/50 text-red-300 border-red-700', pdf: [254, 226, 226] };
const NOTR = { tone: 'bg-gray-700 text-gray-200 border-gray-600', pdf: [243, 244, 246] };

export const ALT_TESIS_TR = {
  futbol_sahasi: 'Futbol Sahası', voleybol_sahasi: 'Voleybol Sahası', hentbol_sahasi: 'Hentbol Sahası',
  basketbol_sahasi: 'Basketbol Sahası', tenis_sahasi: 'Tenis Sahası', atletizm_sahasi: 'Atletizm Sahası',
};
const EVET_HAYIR = { evet: 'Evet', hayir: 'Hayır' };
const VAR_YOK = { var: 'Var', yok: 'Yok' };
const YANGIN_TR = { var: 'Uygun', yok: 'Uygun Değil' };

const bos = (v) => v === undefined || v === null || v === '' || v === 'none';
const kod = (map, v) => (bos(v) ? '' : map[v] || v);

export const fmtTarih = (v) => {
  if (bos(v)) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString('tr-TR');
};
export const fmtTarihSaat = (v) => {
  if (bos(v)) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString('tr-TR');
};
export const fmtAlan = (v) => {
  if (bos(v)) return '';
  const n = parseFloat(String(v).replace(/[^0-9.,]/g, '').replace(',', '.'));
  return Number.isNaN(n) || n === 0 ? '' : `${n.toLocaleString('tr-TR')} m²`;
};
export const fmtTL = (v) => {
  if (bos(v)) return '';
  const n = parseFloat(String(v).replace(/[^0-9.,-]/g, '').replace(',', '.'));
  return Number.isNaN(n) ? String(v) : `${n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
};
export const kalanGun = (bitis) => {
  if (bos(bitis)) return null;
  const d = new Date(bitis);
  if (Number.isNaN(d.getTime())) return null;
  return Math.ceil((d.setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000);
};
export const kalanGunText = (bitis) => {
  const g = kalanGun(bitis);
  if (g === null) return '';
  return g < 0 ? `${Math.abs(g)} gün geçti` : g === 0 ? 'Bugün bitiyor' : `${g} gün kaldı`;
};
export const kalanGunStil = (bitis) => {
  const g = kalanGun(bitis);
  if (g === null) return null;
  return g < 0 ? OLUMSUZ : g <= 30 ? { tone: 'bg-amber-900/50 text-amber-300 border-amber-700', pdf: [254, 243, 199] } : OLUMLU;
};

export const ekParselText = (p) => [p?.pafta && `Pafta ${p.pafta}`, p?.ada && `Ada ${p.ada}`, p?.parsel && `Parsel ${p.parsel}`].filter(Boolean).join(' / ');
export const konumMetni = (e) => [e.mahalle, e.ilce, e.il].filter(Boolean).join(', ');
export const emlakBaslik = (e) => e.tesis_adi || [turInfo(e.tasinmaz_turu).label, e.ilce].filter(Boolean).join(' - ');

export const KONUM_KIND = {
  kayit: { text: 'Kayıtlı koordinat', zoom: 16, span: 0.0035, tone: 'text-emerald-300' },
  mahalle: { text: 'Yaklaşık — mahalle merkezi', zoom: 14, span: 0.012, tone: 'text-amber-300' },
  ilce: { text: 'Yaklaşık — ilçe merkezi', zoom: 12, span: 0.05, tone: 'text-amber-300' },
};

// Satır formatı: [etiket, değer, stil?] — stil: {tone (Tailwind rozet), pdf ([r,g,b] hücre dolgusu)}
export const temelSatirlari = (e) => {
  const yapi = isYapiTuru(e.tasinmaz_turu);
  const tipler = tesisTuruList(e.tesis_turu);
  const rows = [['Taşınmaz Türü', turInfo(e.tasinmaz_turu).label, turInfo(e.tasinmaz_turu)], ['Tesis Türü', tesisTuruText(e.tesis_turu)]];
  if (tipler.includes('spor_tesisi')) rows.push(['Alt Tesis Türü', kod(ALT_TESIS_TR, e.alt_tesis_turu)]);
  if (tipler.includes('diger')) rows.push(['Diğer Tesis Türü', e.diger_tesis_turu]);
  rows.push(['Tesis Adı', e.tesis_adi]);
  if (yapi) rows.push(['Yapım Yılı', e.yapim_yili], ['İnşaat Alanı', fmtAlan(e.insaat_alani_m2)], ['Çatı Alanı', fmtAlan(e.cati_alani_m2)]);
  rows.push([yapi ? 'Arsa Alanı' : 'Alan', fmtAlan(e.alan_m2)]);
  if (e.tasinmaz_turu === 'yapi_yikildi') rows.push(['Yıkım Tarihi', fmtTarih(e.yikim_tarihi), OLUMSUZ], ['Yıkım Nedeni / Notu', e.yikim_notu]);
  return rows;
};

export const konumSatirlari = (e) => [
  ['İl', e.il], ['İlçe', e.ilce], ['Mahalle', e.mahalle],
  ['Pafta', e.pafta], ['Ada', e.ada], ['Parsel', e.parsel],
  ['Ek Parseller', (e.parseller || []).map(ekParselText).filter(Boolean).join(' • ')],
  ['Koordinat', e.enlem && e.boylam ? `${e.enlem}, ${e.boylam}` : ''],
];

export const mulkiyetSatirlari = (e) => {
  const rows = [['Mülkiyet', mulkiyetText(e), e.mulkiyet === 'il_mudurlugu_kamulastirma' ? { tone: 'bg-amber-900/50 text-amber-300 border-amber-700', pdf: [254, 243, 199] } : undefined]];
  if (e.mulkiyet === 'belediye') rows.push(['Belediye', belediyeText(e.belediye)]);
  if (e.mulkiyet === 'kamu_kurum') rows.push(['Kamu Kurum Adı', e.kamu_kurum_adi]);
  if (e.mulkiyet === 'diger') rows.push(['Diğer Mülkiyet Açıklaması', e.diger_mulkiyet_aciklama]);
  const t = e.tahsis_verildi_mi;
  rows.push(['Tahsis / Kira Durumu', kod(TAHSIS_TR, t), TAHSIS_TONE[t]]);
  if (t === 'tahsis_verildi') rows.push(['Tahsis Edilen Kurum', e.tahsis_edilen_kurum], ['Tahsis Başlangıç', fmtTarih(e.tahsis_baslangic_tarihi)], ['Tahsis Bitiş', fmtTarih(e.tahsis_bitis_tarihi)], ['Tahsis Kalan Süre', kalanGunText(e.tahsis_bitis_tarihi), kalanGunStil(e.tahsis_bitis_tarihi)]);
  if (t === 'kiraya_verildi' || t === 'kiralandi') {
    rows.push([t === 'kiralandi' ? 'Kiralayan / Kiraya Veren' : 'Kiraya Verilen Kurum', e.kiraya_verilen_kurum], ['Kira Başlangıç', fmtTarih(e.kira_baslangic_tarihi)], ['Kira Bitiş', fmtTarih(e.kira_bitis_tarihi)], ['Kira Kalan Süre', kalanGunText(e.kira_bitis_tarihi), kalanGunStil(e.kira_bitis_tarihi)]);
    if (t === 'kiralandi') rows.push(['Kira Bedeli (KDV Dahil)', fmtTL(e.kira_bedeli_kdv_dahil)]);
  }
  rows.push(['Kurumumuza Tahsis Başlangıç', fmtTarih(e.kurum_tahsis_baslangic_tarihi)], ['Kurumumuza Tahsis Bitiş', fmtTarih(e.kurum_tahsis_bitis_tarihi)]);
  if (e.kurum_tahsis_bitis_tarihi) rows.push(['Kurum Tahsisi Kalan Süre', kalanGunText(e.kurum_tahsis_bitis_tarihi), kalanGunStil(e.kurum_tahsis_bitis_tarihi)]);
  return rows;
};

export const kamulastirmaSatirlari = (e) => (e.mulkiyet === 'il_mudurlugu_kamulastirma' ? [
  ['Kamulaştırma Tarihi', fmtTarih(e.kamulastirma_tarihi)], ['Değer Tespit Şirketi', e.deger_tespit_sirketi],
  ['Değer Tespit Bedeli', fmtTL(e.deger_tespit_bedeli)], ['Komisyon Tespit Bedeli', fmtTL(e.komisyon_tespit_bedeli)],
  ['Uzlaşma Bedeli', fmtTL(e.uzlasma_bedeli)],
] : []);

export const hasDepremYangin = (e) => isYapiTuru(e.tasinmaz_turu) || !bos(e.deprem_analizi_yapildi_mi) || !bos(e.guclendirme_ihtiyaci) || !bos(e.yangin_yonetmeligi_uygunlugu);

export const depremYanginSatirlari = (e) => [
  ['Deprem Analizi Yapıldı mı', kod(EVET_HAYIR, e.deprem_analizi_yapildi_mi), e.deprem_analizi_yapildi_mi === 'evet' ? OLUMLU : e.deprem_analizi_yapildi_mi === 'hayir' ? OLUMSUZ : undefined],
  ['Analiz Yapım Tarihi', fmtTarih(e.analiz_yapim_tarihi)],
  ['Yönetmelik', bos(e.hangi_yonetmelik) ? '' : `${e.hangi_yonetmelik} Deprem Yönetmeliği`],
  ['Güçlendirme İhtiyacı', kod(VAR_YOK, e.guclendirme_ihtiyaci), e.guclendirme_ihtiyaci === 'var' ? OLUMSUZ : e.guclendirme_ihtiyaci === 'yok' ? OLUMLU : undefined],
  ['Güçlendirme Tarihi', fmtTarih(e.guclendirme_tarihi)],
  ['Yangın Yönetmeliği Uygunluğu', kod(YANGIN_TR, e.yangin_yonetmeligi_uygunlugu), e.yangin_yonetmeligi_uygunlugu === 'var' ? OLUMLU : e.yangin_yonetmeligi_uygunlugu === 'yok' ? OLUMSUZ : undefined],
  ['Uygun Hale Getiriliş Tarihi', fmtTarih(e.yangin_uygun_tarih)],
];

export const kayitSatirlari = (e) => [
  ['Kayıt No', e.id ? e.id.slice(-8).toUpperCase() : ''], ['Oluşturma', fmtTarihSaat(e.created_at)],
  ['Son Güncelleme', fmtTarihSaat(e.last_modified_at || e.updated_at)], ['Son Düzenleyen', e.last_modified_by_name],
];

export { NOTR };
